export default __webpack_public_path__ + "static/media/Level30.8fceca30.svg";